import React, { useState, useEffect } from 'react'
import './Navbar.scss'
import { HiMenuAlt4, HiX} from 'react-icons/hi'
import { motion, AnimatePresence } from 'framer-motion'


const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (toggle) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [toggle]);

  const handleLinkClick = (e, item) => {
    e.preventDefault();
    setToggle(false);
    
    // Small delay to let menu close, then scroll
    setTimeout(() => {
      const element = document.getElementById(item);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  };

  const closeMenu = () => {
    setToggle(false);
  };

  return (
    <>
      <nav className="app__navbar">
        <div className="app__navbar-logo">
          <a className='app__navbar-home' href='#home'>
            <motion.span 
              className='app__title'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              <motion.span 
                className="title-first"
                initial={{ opacity: 0, y: -30, rotateX: -90 }}
                animate={{ opacity: 1, y: 0, rotateX: 0 }}
                transition={{ 
                  duration: 0.8, 
                  delay: 0.2,
                  ease: [0.16, 1, 0.3, 1]
                }}
              >
                Elisabeth
              </motion.span>
              <motion.span 
                className="title-last"
                initial={{ opacity: 0, y: -30, rotateX: -90 }}
                animate={{ opacity: 1, y: 0, rotateX: 0 }}
                transition={{ 
                  duration: 0.8, 
                  delay: 0.5,
                  ease: [0.16, 1, 0.3, 1]
                }}
              >
                &nbsp;Ashley
              </motion.span>
            </motion.span>
          </a>
        </div>
        <ul className="app__navbar-links">
          {['work', 'experience', 'articles', 'reviews', 'contact'].map((item) => (
            <li className="app__flex p-text" key={`link-${item}`}>
              <div />
              <a href={`#${item}`}>{item}</a>
            </li>
          ))}
        </ul>

        <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle(true)} />
        </div>
      </nav>

      {/* Mobile menu - rendered outside nav to avoid container constraints */}
      <AnimatePresence>
        {toggle && (
          <>
            {/* Backdrop overlay */}
            <motion.div
              className="app__navbar-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25 }}
              onClick={closeMenu}
            />
            
            {/* Slide-in menu */}
            <motion.div
              className="app__navbar-sidebar"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ 
                type: 'spring',
                damping: 25,
                stiffness: 200,
                duration: 0.3
              }}
            >
              <button 
                className="app__navbar-close"
                onClick={closeMenu}
                aria-label="Close menu"
              >
                <HiX />
              </button>
              <ul>
                {['work', 'experience', 'articles', 'reviews', 'contact'].map((item) => (
                  <li key={item}>
                    <a 
                      href={`#${item}`} 
                      onClick={(e) => handleLinkClick(e, item)}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar